'use strict';

exports.__esModule = true;
exports.Star = exports.Stars = undefined;

var _trunc = require('babel-runtime/core-js/math/trunc');

var _trunc2 = _interopRequireDefault(_trunc);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

var _starsItem = require('../../src/styles/stars-item.scss');

var _starsItem2 = _interopRequireDefault(_starsItem);

var _stars = require('../../src/styles/stars.scss');

var _stars2 = _interopRequireDefault(_stars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STARS_THEME_DEFAULT = 'STARS_THEME_DEFAULT';
var STARS_THEME_BLACK_AND_WHITE = 'STARS_THEME_BLACK_AND_WHITE';

var STARS_SIZE_XS = 'STARS_SIZE_XS';
var STARS_SIZE_S = 'STARS_SIZE_S';
var STARS_SIZE_M = 'STARS_SIZE_M';
var STARS_SIZE_L = 'STARS_SIZE_L';

var STARS_SIZES = [STARS_SIZE_XS, STARS_SIZE_S, STARS_SIZE_M, STARS_SIZE_L];

var Stars = function Stars(props) {
    var rate = props.rate,
        starsCount = props.starsCount,
        isReview = props.isReview,
        isShrinked = props.isShrinked,
        classNames = props.classNames;

    var lastFilledIndex = Math.floor(rate) - 1;

    var styles = classNames ? (0, _extends3.default)({}, _starsItem2.default, classNames) : _stars2.default;

    var size = isShrinked && STARS_SIZE_XS || props.size;

    var stars = [];

    for (var i = 0; i < starsCount; i++) {
        var quatersToFill = void 0;

        // Count number of quaters to fill
        if (i <= lastFilledIndex) {
            quatersToFill = 4;
        } else {
            var a = rate - i; // look if star should be partially filled
            if (a > 0) {
                var b = a - (0, _trunc2.default)(a);
                var c = b / 0.25;
                quatersToFill = Math.round(c);
            }
        }

        stars.push(_react2.default.createElement(Star, {
            isFilled: i <= lastFilledIndex,
            quatersToFill: quatersToFill,
            index: i,
            isReview: isReview,
            classNames: props.starItemClassNames,
            theme: props.theme,
            size: size
        }));
    }

    return _react2.default.createElement(
        'div',
        { className: styles['stars'] },
        stars
    );
};

Stars.propTypes = {
    rate: _propTypes2.default.number,
    starsCount: _propTypes2.default.number,
    starItemClassNames: _propTypes2.default.object,
    theme: _propTypes2.default.oneOf([STARS_THEME_DEFAULT, STARS_THEME_BLACK_AND_WHITE]),
    isShrinked: _propTypes2.default.bool, // deprecated
    size: _propTypes2.default.oneOf(STARS_SIZES)
};

Stars.defaultProps = {
    rate: 0,
    starsCount: 5,
    starItemClassNames: {},
    theme: STARS_THEME_DEFAULT,
    isShrinked: false, // deprecated
    size: STARS_SIZE_L
};

Stars.STARS_THEME_DEFAULT = STARS_THEME_DEFAULT;
Stars.STARS_THEME_BLACK_AND_WHITE = STARS_THEME_BLACK_AND_WHITE;

var Star = function Star(props) {
    var isFilled = props.isFilled,
        isReview = props.isReview,
        quatersToFill = props.quatersToFill,
        size = props.size;


    var styles = props.classNames ? (0, _extends3.default)({}, _starsItem2.default, props.classNames) : _starsItem2.default;

    var className = (0, _classnames2.default)(styles['stars-item'], styles['mr-3'], styles['stars-item--smaller'], styles['stars-item--' + size], isReview && styles['stars-item--review'], (isFilled || quatersToFill > 0) && styles['stars-item--filled'], quatersToFill && styles['stars-item--' + quatersToFill + '-4'], props.theme === STARS_THEME_BLACK_AND_WHITE && styles['stars-item--white']);

    return _react2.default.createElement('i', { className: className });
};

Star.propTypes = {
    isFilled: _propTypes2.default.bool,
    index: _propTypes2.default.number.isRequired,
    theme: _propTypes2.default.oneOf([STARS_THEME_DEFAULT, STARS_THEME_BLACK_AND_WHITE]),
    isShrinked: _propTypes2.default.bool, // deprecated
    size: _propTypes2.default.oneOf(STARS_SIZES)
};

Star.defaultProps = {
    isFilled: false,
    theme: STARS_THEME_DEFAULT,
    isShrinked: false,
    size: STARS_SIZE_L
};

exports.Stars = Stars;
exports.Star = Star;